import { Add as MAdd } from '@mui/icons-material'

export const Add = () => {
  return <MAdd />
}
